import _ from 'lodash'
import { MutationTree } from 'vuex'
import {
  Information,
  Announce,
  LessonSchedule,
  MypageState,
  Lesson,
  Event,
} from '@/store/mypage/types'
import { Deadline, DeadlineWaitingApproved } from '@/store/deadlines/types'
import { Application } from '@/store/applications/types'

const mutations: MutationTree<MypageState> = {
  /**
   * チューターに紐づくレッスンスケジュール
   *
   * @param {{
   *  fiscalYearSemester: FiscalYearSemester, // 年度・学期
   *  lessons: Lesson[], // レッスン一覧
   * }} チューターに紐づくレッスン一覧
   */
  fetchedTutorLessonSchedules: (
    state,
    { lessonSchedules }: { lessonSchedules: LessonSchedule[] },
  ) => {
    state.lessonSchedules = lessonSchedules
  },

  fetchedMypageLessons: (
    state,
    { data }: { data: Lesson[] },
  ) => {
    state.lessons = data
  },

  fetchedInformations: (state, data: Information[]) => {
    state.informations = data
  },

  fetchedAnnounces: (state, data: Announce[]) => {
    state.announces = data
  },

  gotInformation: (state, information: Information) => {
    state.informations = _.uniqBy([information, ...state.informations], 'notificationId')
  },

  fetchedToDoApplications: (state, data: Application[]) => {
    state.toDoApplications = data;
  },

  fetchedToDoDeadlines: (state, data: Deadline[]) => {
    state.toDoDeadlines = data;
  },

  fetchedToDoWaitingApproveds: (state, data: DeadlineWaitingApproved[]) => {
    state.toDoWaitingApproveds = data;
  },

  fetchedEvents: (
    state,
    { data }: { data: Event[] },
  ) => {
    state.events = data
  },
}

export default mutations
